<template>
  <div>
    <b-form-group
      label="Başlık"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.title"
        placeholder="Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Alt Başlık"
      label-for="subtitle"
    >
      <b-form-input
        id="subtitle"
        v-model="itemData.translate.sub_title"
        placeholder="Alt Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.sub_title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Metin"
      label-for="text"
    >
      <b-form-input
        id="text"
        v-model="itemData.translate.content"
        placeholder="Metin"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.content }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Button"
      label-for="button"
    >
      <b-form-input
        id="button"
        v-model="itemData.translate.button"
        placeholder="Button"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.button }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Bağlantı"
      label-for="url"
    >
      <b-form-input
        id="url"
        v-model="itemData.translate.url"
        placeholder="Bağlantı"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.url }}
        </div>
      </b-alert>
    </b-form-group>
    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BAlert, BButton,
} from 'bootstrap-vue'

export default {
  name: 'Hero',
  components: {
    BFormGroup,
    BFormInput,
    BAlert,
    BButton,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
